/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import React from 'react'
import styles from './Avatar.module.scss'
import {PlayerColor} from '@colonist/game-states'
import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {getLobbyImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'
import {ColonistMembershipProduct} from '../../../../../code/shared/store/ColonistMembershipProduct'
import {navigateToPage} from '../../../../../code/client/shared/scripts/ui_utils/ClientUtils'
import IconAddFriend from '@static/images/icon_add_friend.svg'
import {UIImagePathController} from '../../../../../code/client/shared/scripts/UIEnums.ts'

export interface AvatarProps {
    image?: LobbyImage | undefined
    hideBackground?: boolean
    color?: PlayerColor | undefined
    className?: string
    showPlusIcon?: boolean
    membership?: ColonistMembershipType | undefined
    onClick?: VoidFunction
    profilePictureUrl?: string | undefined
}

export const Avatar = ({
    className = '',
    image,
    color,
    hideBackground,
    showPlusIcon,
    membership,
    onClick,
    profilePictureUrl,
}: AvatarProps) => {
    const hasMembership = membership != null
    const hasLobbyImage = image != null && !profilePictureUrl
    const hasProfilePicture = profilePictureUrl != null
    const hasColor = color != null
    const lobbyImagePath = hasColor && UIImagePathController.playerBackgroundByColor[color]
    const isBotImage = image === LobbyImage.Bot
    return (<div
        className={clsx(styles.container, {[styles.hideBackground]: hideBackground || !hasColor}, className)}
        onClick={onClick}
        style={hasColor
            ? {
                backgroundImage: `url("${lobbyImagePath}")`,
            }
            : {}
        }
    >
        {showPlusIcon && (
            <div className={clsx(styles.icon, styles.plus)}>
                <img className={styles.image} src={IconAddFriend} />
            </div>
        )}

        {hasMembership && (
            <div
                className={clsx(styles.icon, styles.membership)}
                onClick={(e) => {
                    e.stopPropagation()
                    navigateToPage('/store#membership', true)
                }}
            >
                <img className={styles.image} src={getLobbyImagePath(ColonistMembershipProduct.getMembershipProduct(membership).lobbyImage)} />
            </div>
        )}
        {hasLobbyImage && (
            <img
                className={clsx(styles.avatarImage, {
                    [styles.isBot]: isBotImage,
                })}
                src={getLobbyImagePath(image)}
            />
        )}
        {hasProfilePicture && (
            <img
                className={clsx(styles.avatarImage, styles.profilePicture)}
                src={profilePictureUrl}
            />
        )}
    </div>)
}
